import { movies } from "@/mocks/movies";
import type { Movie } from "@/pages/home/types";
import SectionHeading from "@/pages/home/components/SectionHeading";
import MovieCard from "@/pages/home/components/MovieCard";

const picks = movies.filter((m) => m.doubanPick) as Movie[];

export default function DoubanPicks() {
  return (
    <section id="douban" className="scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-8">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="豆瓣高分精选"
            title="被反复讨论的高分片单，口碑经得起时间"
            desc="这里的「豆瓣高分」更接近一个入口标签，指代口碑长期靠前、被反复讨论的作品。下方分数为站内综合评分，用于内部排序与对比，挑选时建议结合简介与类型一起判断。"
            accent="accent"
          />
          <div className="flex shrink-0 items-center gap-3 rounded-lg border border-accent-200 bg-accent-50 p-4">
            <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-500 text-background-50">
              <i className="ri-award-line text-xl" />
            </span>
            <div>
              <p className="font-heading text-lg font-bold text-foreground-950">
                综合评分 9.0 以上
              </p>
              <p className="text-xs text-foreground-600">共 {picks.length} 部入选本期高分精选</p>
            </div>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {picks.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </div>
    </section>
  );
}